const Register = function(): void {
    const redirectForm = <HTMLFormElement>document.getElementById('redirectToArticleForm');
    const redirectBtn = <HTMLButtonElement>document.getElementById('redirectToArticleBtn');
    
    const contentRedirect = 'contentRedirect';
    const sportRedirect = 'sportRedirect';

    if (!redirectForm)
        return;

    redirectForm.addEventListener('change', () => {
        if (redirectForm.checkValidity()) {
            redirectBtn.disabled = false;
        }
    });

    redirectForm.addEventListener('submit', (ev) => {
        if (!redirectForm.checkValidity())
            return;

        ev.preventDefault();
        const formData = new FormData(redirectForm);
        const contentRedirectValue = formData.get(contentRedirect);
        const sportRedirectValue = formData.get(sportRedirect);
        
        window.location.href = `/seriesport/${contentRedirectValue}/${sportRedirectValue}/create`;
    });
}

export default {
    Register
}
